import {useEffect, useState} from "react";
import style from '../CSS/RoundVideoResult.module.css'


const Details = ({data, name, profile, subTitle}) => {
    const [items, setItems] = useState(null);

    useEffect(()=>{
        setItems(data);
    }, [])
    return (
        <>
            <div className={style.details}>
                <div>
                    <table className={style.table}>
                        <thead className={style.table__head}>
                            <tr>
                                <th>
                                    <p>Total videos</p>
                                </th>
                                <th>
                                    <p>Star Mark</p>
                                </th>
                                <th>
                                    <p>User Mark</p>
                                </th>
                                <th>
                                    <p>Total Mark</p>
                                </th>
                            </tr>
                        </thead>

                        <tbody className={style.table__body}>
                        {
                            items && items.length > 0 && items.map((item, index)=>(
                                <tr key={index} style={{ background: index % 2 == 0 && '#333030'}}>
                                    <td>{index+1 }. <img src={item.video} alt=""/></td>
                                    <td style={{paddingLeft: '30px'}}>{item.star}</td>
                                    <td style={{paddingLeft: '30px'}}>{item.user}</td>
                                    <td style={{paddingLeft: '30px'}}>{ item.star + item.user }</td>
                                </tr>
                            ))
                        }
                        </tbody>
                    </table>
                </div>
            </div>

        </>
    );
};

export default Details;